<template>
  <IQOS required v-if="changes.length > 0">
    <template #title>
      <p class="orange-4-color iqos-icon-align">
        <BaseIcon icon="allert-regular" size="sm"/>
        {{ $t("poster_pending_changes.title") }}
      </p>
    </template>

    <p class="iqos-comment mt-16 qrw-paragraph-md v1-grey-10-color">
      {{ $t("poster_pending_changes.desc") }}
    </p>

    <BaseCheckbox
      class="mt-16"
      v-for="change in changes"
      :key="change._id"
      v-model="batch_map[change._id]"
    >
      <template v-if="change.change_type == 'new_product'">
        {{ change.payload.name }} ({{ change.payload.category }})
        <span class="c-grey">
          - {{ $t("poster_pending_changes.new_product_suffix") }}</span
        >
      </template>

      <template v-else-if="change.change_type == 'new_price_group'">
        {{ change.payload.price_group.name || "" }} ({{
          change.payload.product_name
        }})
        <span class="c-grey">
          - {{ $t("poster_pending_changes.new_price_group_suffix") }}</span
        >
      </template>

      <template v-else-if="change.change_type == 'new_price_group_item'">
        {{ change.payload.price_group_item.name }} ({{
          change.payload.product_name
        }})
        <span class="c-grey">
          - {{ $t("poster_pending_changes.new_price_group_item_suffix") }}</span
        >
      </template>

      <template v-else-if="change.change_type == 'remove_price_group'">
        {{ change.payload.price_group_name || "" }} ({{
          change.payload.product_name
        }})
        <span class="c-grey">
          - {{ $t("poster_pending_changes.remove_price_group_suffix") }}</span
        >
      </template>
    </BaseCheckbox>

    <div class="gap-column-xs w-100 mt-16">
      <BaseButton
        variant="secondary"
        size="md"
        class="w-100"
        :disabled="busy"
        :busy="busy"
        color="v1-grey-10"
        @click="ignoreChanges"
      >
        {{ $t("poster_pending_changes.ignore_btn") }}
      </BaseButton>

      <BaseButton
        variant="primary"
        size="md"
        class="w-100"
        color="green-5"
        :disabled="busy"
        :busy="busy"
        bold
        @click="acceptChanges"
      >
        {{ $t("poster_pending_changes.accept_btn") }}
      </BaseButton>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import PosterAPI from "@/api/poster";

import RoundCheckbox from "@/components/RoundCheckbox.vue";
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    IQOS,
    RoundCheckbox,
    DashboardButton,
  },
  props: {
    menu_id: String,
  },
  watch: {
    menu_id() {
      this.fetchChanges();
    },
  },
  data() {
    return {
      changes: [],
      busy: false,

      changes_queue: [],

      batch_map: {},
    };
  },
  methods: {
    updatePosLists() {
      if (this.$store.getters.hasPosterIntegration) {
        this.$store.dispatch("poster/fetchProductsList");
      }
    },
    fetchChanges() {
      PosterAPI.getPendingChanges(this.menu_id)
        .then((data) => {
          this.changes = data.changes;
          this.batch_map = {};

          for (const change of this.changes) {
            this.$set(this.batch_map, change._id, true);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    acceptChanges() {
      const sm = {};

      Object.entries(this.batch_map).forEach((e) => {
        sm[e[0]] = e[1] ? "accepted" : "denied";
      });

      this.sendChanges(sm);
    },
    ignoreChanges() {
      const sm = {};

      Object.entries(this.batch_map).forEach((e) => {
        sm[e[0]] = "ignored";
      });

      this.sendChanges(sm);
    },
    sendChanges(map) {
      this.busy = true;

      PosterAPI.batchPendingChanges(map).finally(() => {
        this.applyChanges(map);
      });

      this.updatePosLists();
    },
    eatQueue() {
      if (!this.changes_queue.length) {
        this.busy = false;
        this.changes = [];
        return;
      }

      const change = this.changes_queue.shift();

      let promise;

      if (change.change_type == "new_product") {
        promise = this.$store.dispatch("menu/addProduct", change.payload);
      }

      if (change.change_type == "new_price_group") {
        promise = this.$store.dispatch(
          "menu/addPriceGroupToProduct",
          change.payload
        );
      }

      if (change.change_type == "remove_price_group") {
        promise = this.$store.dispatch(
          "menu/removePriceGroupFromProduct",
          change.payload
        );
      }

      if (change.change_type == "new_price_group_item") {
        promise = this.$store.dispatch(
          "menu/addPriceGroupItemToProduct",
          change.payload
        );
      }

      if (promise) {
        promise.finally(() => {
          this.eatQueue();
        });
      } else {
        this.eatQueue();
      }
    },
    applyChanges(map) {
      const accepted_ids = Object.entries(map)
        .filter((e) => {
          return e[1] == "accepted";
        })
        .map((e) => e[0]);

      this.changes_queue = this.changes.filter((c) =>
        accepted_ids.includes(c._id)
      );
      this.eatQueue();
    },
  },
  mounted() {
    this.fetchChanges();
  },
};
</script>

<style scoped>
.changes-controls {
  display: flex;
  justify-content: space-between;
}
</style>